import { useRealtyCalculate } from "../../../../common/api/queries";
import { CalcType } from "../../enums";
import { createCalcResultsContext } from "../contexts/calcResultsContext";
import { RealtyCalc, RealtyCalcResultData } from "./types";

export const { Provider: RealtyCalcResultsProvider, useCalcResults: useRealtyCalcResults } = createCalcResultsContext<
  RealtyCalc,
  RealtyCalcResultData,
  CalcType.REALTY
>(useRealtyCalculate);
